import React from "react";
import { useParams } from "react-router-dom";
import "../assets/css/JobDetails.css";
import image from "../assets/Hero/hero_4.jpg"

export const JobDetails = ({ data }) => {
  const { jobId } = useParams(); // Get the job ID from the URL
  const job = data.find((job) => job.id === parseInt(jobId)); // Find the job by ID

  if (!job) {
    return <div className="job-details-not-found">Job not found!</div>;
  }

  return (
    <div className="job-details-page">
      {/* Hero Section */}
      <div className="job-details-hero">
        <img
          src={image}
          alt={`${job.title} Hero`}
          className="job-details-hero-image"
        />
        <div className="job-details-hero-text">
          <h1 className="job-details-title">{job.title}</h1>
          <p className="job-details-subtitle">{job.description}</p>
        </div>
      </div>

      {/* Details Section */}
      <div className="job-details-container">
        <section className="job-details-section">
          <h2 className="job-details-heading">Must Haves</h2>
          <ul className="job-details-list">
            {job.mustHaves.map((item, i) => (
              <li key={i} className="job-details-list-item">
                {item}
              </li>
            ))}
          </ul>
        </section>
        <section className="job-details-section">
          <h2 className="job-details-heading">Preferred Skills</h2>
          <ul className="job-details-list">
            {job.preferredSkills.map((item, i) => (
              <li key={i} className="job-details-list-item">
                {item}
              </li>
            ))}
          </ul>
        </section>
        <section className="job-details-section">
            <h2 className="job-details-heading">How to Apply</h2>
            <p className="job-details-paragraph">
                Please submit your resume and supporting certificates in a <b>zip file</b> to{" "}
                <a
                href="mailto:careers@defttech.co.ke"
                className="job-details-email-link"
                >
                careers@defttech.co.ke
                </a>{" "}
                outlining your experience with functional implementation and your interest
                in working with Microsoft Dynamics 365 solutions.
            </p>
            <p className="job-details-paragraph">
                <strong className="job-details-deadline">
                Application deadline is 29th of November 2024.
                </strong>
            </p>
            <p className="job-details-paragraph">
                We are an equal opportunity employer and value diversity at our company. We
                do not discriminate on the basis of race, religion, color, national origin,
                gender, sexual orientation, age, marital status, veteran status, or
                disability status.
            </p>
            <p className="job-details-paragraph job-details-note">
                <strong>NOTE:</strong> Only shortlisted applicants will be contacted.
            </p>
        </section>
        <button
          onClick={() => window.history.back()}
          className="job-details-back-btn"
        >
          Go Back
        </button>
      </div>
    </div>
  );
};
